import { baseAPI } from "../../../baseApi";
import { tagsTypes } from "../../../tagsTypes";

export const productReviewSlice = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    // Save product for review
    postProductForReview: builder.mutation({
      query: (data) => ({
        url: "product-submit",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagsTypes.GET_PRODUCT_LIST, tagsTypes.GET_PRODUCT_DETAIL],
    }),
  }),
});

export const { usePostProductForReviewMutation } = productReviewSlice;
